/**
 * Wizard live poll / SSE / slot merge (from flow.attach).
 * Mutates shared liveRuntime + liveFlags — do not copy those primitives.
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardFlowLive) return;
  global.WorkshopBookingWizardFlowLive = {
    attach: function (S) {
      if (!S || !S.liveRuntime) return;
      var wizardRoot = S.wizardRoot;
      var buildDaysMap = S.buildDaysMap;
      var eventsToSlots = S.eventsToSlots;
      var getLiveApi = S.getLiveApi;
      var liveController = S.liveController;
      var liveFlags = S.liveFlags;
      var R = S.liveRuntime;
      var slotBookable = S.slotBookable;
      var slotDateKey = S.slotDateKey;
      var slotVisible = S.slotVisible;
      var state = S.state;
      var stepEl = S.stepEl;

      function slotsForDate(key) {
        return typeof S.slotsForDate === 'function' ? S.slotsForDate(key) : [];
      }
      function slotSyncKey(slot) {
        return typeof S.slotSyncKey === 'function' ? S.slotSyncKey(slot) : '';
      }
      function findSlotBySyncKey(key) {
        return typeof S.findSlotBySyncKey === 'function' ? S.findSlotBySyncKey(key) : null;
      }
      function softRefreshDatetimeTimeUi() {
        if (typeof S.softRefreshDatetimeTimeUi === 'function') S.softRefreshDatetimeTimeUi();
      }
      function renderCalendar(opts) {
        if (typeof S.renderCalendar === 'function') S.renderCalendar(opts);
      }
      function applyPopupLiveRefresh(flags) {
        if (typeof S.applyPopupLiveRefresh === 'function') S.applyPopupLiveRefresh(flags);
      }
      function syncCapacityRing() {
        if (typeof S.syncCapacityRing === 'function') S.syncCapacityRing();
      }

      function resetLiveCursors() {
        R.lastLiveBatchAsOf = 0;
        R.lastLiveApplyAt = 0;
      }

    var MONTH_SWEEP_MS = 20000;

    function slotMatchKey(slot) {
      if (!slot) return '';
      var liveApi = getLiveApi();
      if (liveApi && typeof liveApi.canonicalEventId === 'function') {
        var liveKey = liveApi.canonicalEventId(slot);
        if (liveKey) return liveKey;
      }
      var raw = slot._raw || {};
      return String(
        slot.canonical_event_id ||
          raw.canonical_event_id ||
          raw.event_metaobject_gid ||
          raw.event_id ||
          raw.id ||
          slot.gid ||
          ''
      ).trim();
    }

    function replaceSelectedSlotFromList(slots) {
      if (!state.selectedSlot || !Array.isArray(slots)) return;
      var key = slotMatchKey(state.selectedSlot);
      var sync = slotSyncKey(state.selectedSlot);
      if (!key && !sync) return;
      for (var i = 0; i < slots.length; i++) {
        if ((key && slotMatchKey(slots[i]) === key) || (sync && slotSyncKey(slots[i]) === sync)) {
          state.selectedSlot = slots[i];
          return;
        }
      }
    }

    function syncSelectedVenueEventsFromSlots(slots) {
      if (!state.selectedVenue || !Array.isArray(slots)) return;
      state.selectedVenue.events = slots.map(function (slot) {
        return slot && slot._raw ? slot._raw : slot;
      });
    }

    function batchAsOfMs(slots) {
      var max = 0;
      (slots || []).forEach(function (slot) {
        if (!slot || !slot.capacity_as_of) return;
        var t = Date.parse(String(slot.capacity_as_of));
        if (Number.isFinite(t) && t > max) max = t;
      });
      return max;
    }

    function shouldApplyLiveSlots(slots, meta) {
      var at = meta && meta.at != null ? meta.at : Date.now();
      var asOfMs = batchAsOfMs(slots);
      if (asOfMs > 0) {
        if (asOfMs < R.lastLiveBatchAsOf) return false;
        R.lastLiveBatchAsOf = asOfMs;
      } else if (at < R.lastLiveApplyAt) {
        return false;
      }
      R.lastLiveApplyAt = at;
      return true;
    }

    function startMonthSweep(ms) {
      if (R.monthSweepTimer) clearInterval(R.monthSweepTimer);
      R.monthSweepTimer = setInterval(function () {
        if (document.hidden) return;
        sweepViewMonthLive();
      }, ms);
    }

    function stopMonthSweep() {
      if (!R.monthSweepTimer) return;
      clearInterval(R.monthSweepTimer);
      R.monthSweepTimer = 0;
    }

    function schedulePushRefresh() {
      // Coalesce while ATC is in flight or the tab is hidden — do not drop
      // the engine revision. Flush when the freeze lifts.
      if (liveFlags.atcInFlight || document.hidden) {
        R.pendingPushWhileHidden = true;
        return;
      }
      if (R.pushRefreshTimer) return;
      R.pendingPushWhileHidden = false;
      R.pushRefreshTimer = setTimeout(function () {
        R.pushRefreshTimer = 0;
        if (liveController && typeof liveController.tickNow === 'function') {
          liveController.tickNow({ force: true });
        }
      }, 400);
    }

    function scheduleCatalogRefresh() {
      if (liveFlags.atcInFlight || document.hidden) {
        R.pendingCatalogWhileHidden = true;
        return;
      }
      if (R.catalogRefreshTimer) return;
      R.pendingCatalogWhileHidden = false;
      R.catalogRefreshTimer = setTimeout(function () {
        R.catalogRefreshTimer = 0;
        var Hub = global.WorkshopBookingWizardHub;
        var booking = S.bookingRoot;
        var isHub = !!(S.wizardRoot && S.wizardRoot.getAttribute('data-wbw-hub') === '1');
        if (isHub && Hub && booking && typeof Hub.reloadOpenCityCatalog === 'function') {
          Hub.reloadOpenCityCatalog(booking);
          return;
        }
        if (liveController && typeof liveController.tickNow === 'function') {
          liveController.tickNow({ force: true });
        }
      }, 400);
    }

    function liveStreamEndpoint() {
      var api = getLiveApi();
      if (api && api.LIVE_STREAM_URL) return String(api.LIVE_STREAM_URL);
      if (api && typeof api.resolveLiveStreamUrl === 'function') return String(api.resolveLiveStreamUrl());
      return 'https://amc-ew.aogen.com.au/api/public/workshop-city/event-live-stream';
    }

    function onSharedStreamEvent(evt) {
      var type = evt && evt.type;
      var scope = (evt && evt.scope) || (evt && evt.payload && evt.payload.scope);
      if (type === 'hello') {
        R.liveStreamOk = true;
        if (liveController && typeof liveController.pauseForStream === 'function') {
          liveController.pauseForStream();
        }
        stopMonthSweep();
        return;
      }
      if (type === 'catalog' || scope === 'catalog') {
        scheduleCatalogRefresh();
        return;
      }
      if (type === 'live') {
        schedulePushRefresh();
        return;
      }
      // Connection dropped: resume hot polling until the stream reconnects.
      R.liveStreamOk = false;
      if (liveController && typeof liveController.resumeFromStream === 'function') {
        liveController.resumeFromStream();
      }
      startMonthSweep(MONTH_SWEEP_MS);
    }

    function bindLiveStream() {
      var Stream = global.WorkshopLiveStream;
      if (Stream && typeof Stream.subscribe === 'function') {
        if (R.liveStreamUnsub) return true;
        if (typeof Stream.isSupported === 'function' && !Stream.isSupported()) return false;
        R.liveStreamUnsub = Stream.subscribe(onSharedStreamEvent);
        return true;
      }
      return bindOwnLiveStream();
    }

    /* Fallback for pages that did not load workshop-live-stream.js. */
    function bindOwnLiveStream() {
      if (R.liveStream || typeof EventSource === 'undefined') return false;
      var shop = window.Shopify && window.Shopify.shop ? String(window.Shopify.shop) : '';
      if (!shop) return false;
      var url = liveStreamEndpoint() + '?shop_domain=' + encodeURIComponent(shop);
      var es;
      try {
        es = new EventSource(url);
      } catch (e) {
        return false;
      }
      var gotHello = false;
      var fails = 0;
      R.liveStream = es;
      es.addEventListener('hello', function () {
        gotHello = true;
        fails = 0;
        R.liveStreamOk = true;
        if (liveController && typeof liveController.pauseForStream === 'function') {
          liveController.pauseForStream();
        }
        stopMonthSweep();
      });
      es.addEventListener('live', function () {
        schedulePushRefresh();
      });
      es.addEventListener('catalog', function () {
        scheduleCatalogRefresh();
      });
      es.onerror = function () {
        R.liveStreamOk = false;
        fails += 1;
        // Connection dropped: resume hot polling until the stream reconnects
        // (EventSource auto-reconnects and will re-send 'hello' to re-pause).
        if (liveController && typeof liveController.resumeFromStream === 'function') {
          liveController.resumeFromStream();
        }
        startMonthSweep(MONTH_SWEEP_MS);
        // Give up only when the browser itself closed the stream (won't retry),
        // or after many pre-hello failures. Transient CONNECTING blips keep
        // auto-reconnecting; ensureStreamHealthy() rebinds later if needed.
        var browserClosed =
          typeof EventSource !== 'undefined' && es.readyState === EventSource.CLOSED;
        if (browserClosed || (!gotHello && fails >= 5)) {
          es.close();
          if (R.liveStream === es) R.liveStream = null;
        }
      };
      return true;
    }

    function ensureStreamHealthy() {
      if (!R.pollStarted || typeof EventSource === 'undefined') return;
      var Stream = global.WorkshopLiveStream;
      if (Stream && R.liveStreamUnsub) {
        Stream.ensureHealthy();
        if (typeof Stream.isOk === 'function' && !Stream.isOk()) {
          if (liveController && typeof liveController.resumeFromStream === 'function') {
            liveController.resumeFromStream();
          }
        }
        return;
      }
      if (R.liveStream && R.liveStream.readyState !== EventSource.CLOSED) return;
      if (R.liveStream) {
        try { R.liveStream.close(); } catch (e) {}
        R.liveStream = null;
      }
      if (liveController && typeof liveController.resumeFromStream === 'function') {
        liveController.resumeFromStream();
      }
      bindLiveStream();
    }

    function teardownLiveStream() {
      if (R.liveStreamUnsub) {
        try { R.liveStreamUnsub(); } catch (e) {}
        R.liveStreamUnsub = null;
        R.liveStreamOk = false;
      }
      if (R.liveStream) {
        try { R.liveStream.close(); } catch (e) {}
        R.liveStream = null;
      }
      if (R.monthSweepTimer) {
        clearInterval(R.monthSweepTimer);
        R.monthSweepTimer = 0;
      }
      if (R.pushRefreshTimer) {
        clearTimeout(R.pushRefreshTimer);
        R.pushRefreshTimer = 0;
      }
      if (R.catalogRefreshTimer) {
        clearTimeout(R.catalogRefreshTimer);
        R.catalogRefreshTimer = 0;
      }
      if (R.liveFollowupTimer) {
        clearTimeout(R.liveFollowupTimer);
        R.liveFollowupTimer = 0;
      }
      if (R.liveFlushTimer) {
        clearTimeout(R.liveFlushTimer);
        R.liveFlushTimer = 0;
      }
      R.pendingLiveSlots = null;
      if (liveController && typeof liveController.pauseForStream === 'function') {
        liveController.pauseForStream();
      }
    }

    function bindStreamLifecycleOnce() {
      if (R.streamLifecycleBound) return;
      R.streamLifecycleBound = true;
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        ensureStreamHealthy();
        if (R.pendingPushWhileHidden) schedulePushRefresh();
        if (R.pendingCatalogWhileHidden) scheduleCatalogRefresh();
      });
      window.addEventListener('pageshow', function (e) {
        if (e && e.persisted) {
          ensureStreamHealthy();
          if (R.pendingPushWhileHidden) schedulePushRefresh();
          if (R.pendingCatalogWhileHidden) scheduleCatalogRefresh();
        }
      });
      window.addEventListener('pagehide', teardownLiveStream);
      document.addEventListener('shopify:section:unload', function (e) {
        var sid = wizardRoot && wizardRoot.getAttribute('data-section-id');
        var evSid = e && e.detail && e.detail.sectionId;
        if (sid && evSid && String(sid) !== String(evSid)) return;
        teardownLiveStream();
      });
    }

    function ensureLivePoll() {
      if (!liveController || R.pollStarted) return;
      if (typeof liveController.startPoll !== 'function') return;
      liveController.startPoll(slotsForLivePoll, applyLiveSlots, { immediate: false });
      R.pollStarted = true;
      bindLiveStream();
      bindStreamLifecycleOnce();
      startMonthSweep(MONTH_SWEEP_MS);
      sweepViewMonthLive();
    }

    function daysKeysFingerprint(daysMap) {
      return Object.keys(daysMap || {}).sort().join('|');
    }

    function slotStructureFingerprint(slots) {
      return (slots || [])
        .map(function (s) {
          if (!s) return '';
          return [slotDateKey(s) || '', String(s.gid || ''), slotVisible(s) ? '1' : '0'].join(':');
        })
        .sort()
        .join('|');
    }

    function slotBookabilityFingerprint(slots) {
      return (slots || [])
        .map(function (s) {
          if (!s) return '';
          return [
            String(s.gid || ''),
            slotBookable(s) ? '1' : '0',
            slotVisible(s) ? '1' : '0',
            String(s.capacity_remaining != null ? s.capacity_remaining : ''),
          ].join(':');
        })
        .sort()
        .join('|');
    }

    function slotBookableBitFingerprint(slots) {
      return (slots || [])
        .map(function (s) {
          if (!s) return '';
          return [String(s.gid || ''), slotBookable(s) ? '1' : '0', slotVisible(s) ? '1' : '0'].join(':');
        })
        .sort()
        .join('|');
    }

    function mergeLiveSlotsIntoList(freshSlots) {
      if (!Array.isArray(freshSlots) || !freshSlots.length) return;
      if (!Array.isArray(state.slotList) || !state.slotList.length) {
        state.slotList = freshSlots.slice();
        return;
      }
      var byKey = Object.create(null);
      freshSlots.forEach(function (s) {
        var k = slotMatchKey(s) || slotSyncKey(s);
        if (k) byKey[k] = s;
      });
      for (var i = 0; i < state.slotList.length; i++) {
        var key = slotMatchKey(state.slotList[i]) || slotSyncKey(state.slotList[i]);
        if (key && byKey[key]) state.slotList[i] = byKey[key];
      }
    }

    function slotsInViewMonth() {
      var vm = state.viewMonth instanceof Date ? state.viewMonth : new Date();
      var prefix = vm.getFullYear() + '-' + String(vm.getMonth() + 1).padStart(2, '0');
      return (state.slotList || []).filter(function (s) {
        return String(slotDateKey(s) || '').indexOf(prefix) === 0;
      });
    }

    function slotsForHotLivePoll() {
      var out = [];
      var seen = Object.create(null);
      function add(s) {
        if (!s) return;
        var k = slotMatchKey(s) || slotSyncKey(s);
        if (!k || seen[k]) return;
        seen[k] = true;
        out.push(s);
      }
      add(state.selectedSlot);
      Object.keys(state.variantWhen || {}).forEach(function (id) {
        var w = state.variantWhen[id];
        if (w && w.gid) add(findSlotBySyncKey(w.gid));
      });
      if (state.selectedDate) slotsForDate(state.selectedDate).forEach(add);
      return out;
    }

    function viewMonthBounds() {
      var vm = state.viewMonth instanceof Date ? state.viewMonth : new Date();
      var y = vm.getFullYear();
      var m = vm.getMonth();
      var last = new Date(y, m + 1, 0).getDate();
      return {
        from: y + '-' + String(m + 1).padStart(2, '0') + '-01',
        to: y + '-' + String(m + 1).padStart(2, '0') + '-' + String(last).padStart(2, '0'),
      };
    }

    function slotsForLivePoll() {
      var out = slotsForHotLivePoll();
      if (out.length) return out;
      var keys = Object.keys(state.daysWithEvents || {}).sort();
      for (var i = 0; i < keys.length && i < 8; i++) {
        slotsForDate(keys[i]).forEach(function (s) {
          out.push(s);
        });
      }
      return out;
    }

    function sweepViewMonthLive(opts) {
      // Freeze live updates while an add-to-cart is being validated/submitted:
      // returning before the fetch keeps _wbLiveSince intact so no revision is
      // skipped, and prevents the selection from being mutated mid-submit.
      if (liveFlags.atcInFlight) return Promise.resolve();
      var api = getLiveApi();
      if (!api || typeof api.fetchLiveState !== 'function') return Promise.resolve();
      var slots = state.slotList || [];
      var gids =
        typeof api.collectEventGids === 'function' ? api.collectEventGids(slots) : [];
      if (!gids.length) return Promise.resolve();
      var venue = state.selectedVenue;
      var venueKey = venue
        ? String(venue.handle || venue.product_handle || venue.venue_ref_id || '').trim()
        : '';
      return api
        .fetchLiveState(gids, {
          force: !!(opts && opts.force),
          root: wizardRoot,
          shopDomain: window.Shopify && window.Shopify.shop ? String(window.Shopify.shop) : '',
        })
        .then(function (result) {
          if (!result) return;
          var cur = state.selectedVenue;
          var curKey = cur
            ? String(cur.handle || cur.product_handle || cur.venue_ref_id || '').trim()
            : '';
          if (venueKey && curKey && venueKey !== curKey) return;
          if (liveFlags.atcInFlight) return;
          if (result.as_of) state._wbLiveSince = result.as_of;
          if (result.unchanged) return;
          if (!result.states || !Object.keys(result.states).length) return;
          var fresh =
            typeof api.mergeSlotsWithLive === 'function'
              ? api.mergeSlotsWithLive(state.slotList || [], result.states, result.as_of)
              : state.slotList;
          if (Array.isArray(fresh) && fresh.length) applyLiveSlots(fresh, { at: Date.now() });
        })
        .catch(function () {});
    }

    function scheduleLiveFollowup() {
      if (R.liveFollowupTimer) clearTimeout(R.liveFollowupTimer);
      R.liveFollowupTimer = setTimeout(function () {
        R.liveFollowupTimer = 0;
        if (liveController && typeof liveController.tickNow === 'function') {
          liveController.tickNow({ force: true });
        }
      }, 520);
    }

    function refreshLiveNow(opts) {
      opts = opts || {};
      ensureLivePoll();
      var pending;
      if (liveController && typeof liveController.tickNow === 'function') {
        pending = liveController.tickNow({ force: opts.force !== false });
      } else {
        pending = quietEnrichCurrentSlots(null, { force: opts.force !== false });
      }
      return Promise.resolve(pending).then(function (result) {
        if (opts.followup === true || (result && result.ok === false && !result.deferred)) {
          scheduleLiveFollowup();
        }
        return result;
      });
    }

    /* A background refresh must never move something the visitor is using:
       an open time dropdown or a focused field inside the step defers the paint
       until they are done. The revision is held, not dropped. */
    function liveUiBusy() {
      if (typeof S.isCalTimeDdOpen === 'function' && S.isCalTimeDdOpen()) return true;
      var active = document.activeElement;
      if (!active || active === document.body) return false;
      var step = stepEl(state.branch === 'variants' ? 'variants' : 'datetime');
      if (!step || !step.contains(active)) return false;
      var tag = String(active.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'select' || tag === 'textarea') return true;
      return active.getAttribute && active.getAttribute('aria-expanded') === 'true';
    }

    function scheduleLiveFlush() {
      if (R.liveFlushTimer) return;
      R.liveFlushTimer = setTimeout(function () {
        R.liveFlushTimer = 0;
        var pending = R.pendingLiveSlots;
        if (!pending) return;
        if (liveUiBusy()) {
          scheduleLiveFlush();
          return;
        }
        R.pendingLiveSlots = null;
        applyLiveSlots(pending.slots, pending.meta);
      }, 500);
    }

    function applyLiveSlots(slots, meta) {
      if (!Array.isArray(slots) || !slots.length) return;
      if (liveFlags.atcInFlight) return;
      if (liveUiBusy()) {
        R.pendingLiveSlots = { slots: slots, meta: meta };
        scheduleLiveFlush();
        return;
      }
      if (!shouldApplyLiveSlots(slots, meta)) return;
      var prevDaysFp = daysKeysFingerprint(state.daysWithEvents);
      var prevStructFp = slotStructureFingerprint(state.slotList);
      var prevBookFp = slotBookabilityFingerprint(state.slotList);
      var prevBookBit = slotBookableBitFingerprint(state.slotList);
      var prevSelectedGid = state.selectedSlot && state.selectedSlot.gid ? String(state.selectedSlot.gid) : '';
      mergeLiveSlotsIntoList(slots);
      state.daysWithEvents = buildDaysMap(state.slotList);
      syncSelectedVenueEventsFromSlots(state.slotList);
      replaceSelectedSlotFromList(state.slotList);
      /* Losing a selection is the one live change the visitor must be told about,
         otherwise their date or time silently vanishes under them. */
      var priorDate = state.selectedDate || '';
      var lostMsg = '';
      if (state.selectedSlot && !slotVisible(state.selectedSlot)) {
        state.selectedSlot = null;
        lostMsg = 'This session is sold out — pick another time';
      }
      if (priorDate && !state.daysWithEvents[priorDate]) {
        if (state._wbwUserPickedCalDate) {
          state.selectedSlot = null;
          lostMsg = 'That date just filled up — pick another day';
        } else {
          // Auto-selected date: nothing the visitor chose was lost, stay quiet.
          state.selectedDate = '';
          state.selectedSlot = null;
          lostMsg = '';
        }
      }
      if (lostMsg && typeof S.showWizardNotice === 'function') S.showWizardNotice(lostMsg);
      var nextSelectedGid = state.selectedSlot && state.selectedSlot.gid ? String(state.selectedSlot.gid) : '';
      var daysChanged = prevDaysFp !== daysKeysFingerprint(state.daysWithEvents);
      var structureChanged = prevStructFp !== slotStructureFingerprint(state.slotList);
      var bookabilityChanged = prevBookFp !== slotBookabilityFingerprint(state.slotList);
      var bookBitChanged = prevBookBit !== slotBookableBitFingerprint(state.slotList);
      var selectionChanged = prevSelectedGid !== nextSelectedGid;
      var statusChanged = daysChanged || structureChanged || selectionChanged || bookBitChanged;
      if (state.branch === 'datetime') {
        var dtStep = stepEl('datetime');
        var hasDayGrid = !!(
          dtStep &&
          dtStep.querySelector('[data-wbw-cal-grid] [data-wbw-cal-day]')
        );
        if (hasDayGrid) {
          if (statusChanged) softRefreshDatetimeTimeUi();
          else if (bookabilityChanged) syncCapacityRing();
        } else if (statusChanged) {
          renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
        }
      } else if (state.branch === 'variants') {
        if (statusChanged || bookabilityChanged) {
          applyPopupLiveRefresh({
            daysChanged: daysChanged,
            structureChanged: structureChanged,
            selectionChanged: selectionChanged,
            bookabilityChanged: bookabilityChanged,
            bookBitChanged: bookBitChanged,
          });
        }
        syncCapacityRing();
        return;
      }
      syncCapacityRing();
    }

    function enrichSlotsForCurrentVenue(slots, extra) {
      if (!liveController || typeof liveController.enrichSlots !== 'function') {
        return Promise.resolve(slots || []);
      }
      return liveController
        .enrichSlots(slots || [], extra || {})
        .then(function (freshSlots) {
          return freshSlots || slots || [];
        })
        .catch(function () {
          return slots || [];
        });
    }

    function refreshVenueEventsLive(venue) {
      if (!venue || !Array.isArray(venue.events) || !venue.events.length) {
        return Promise.resolve(venue);
      }
      var slots = eventsToSlots(venue.events);
      if (!slots.length) return Promise.resolve(venue);
      return enrichSlotsForCurrentVenue(slots)
        .then(function (freshSlots) {
          venue.events = freshSlots.map(function (slot) {
            return slot && slot._raw ? slot._raw : slot;
          });
          if (state.selectedVenue === venue) {
            state.slotList = freshSlots;
            state.daysWithEvents = buildDaysMap(state.slotList);
            syncSelectedVenueEventsFromSlots(state.slotList);
            replaceSelectedSlotFromList(state.slotList);
          }
          return venue;
        })
        .catch(function () {
          return venue;
        });
    }

    function quietEnrichCurrentSlots(stillFn, extra) {
      var slots = slotsInViewMonth();
      if (!slots.length) slots = Array.isArray(state.slotList) ? state.slotList.slice() : [];
      if (!slots.length) return Promise.resolve(slots);
      return enrichSlotsForCurrentVenue(slots, extra).then(function (fresh) {
        if (typeof stillFn === 'function' && !stillFn()) return state.slotList;
        if (!Array.isArray(fresh) || !fresh.length) return state.slotList;
        applyLiveSlots(fresh, { at: Date.now() });
        return state.slotList;
      });
    }

      S.slotMatchKey = slotMatchKey;
      S.replaceSelectedSlotFromList = replaceSelectedSlotFromList;
      S.syncSelectedVenueEventsFromSlots = syncSelectedVenueEventsFromSlots;
      S.batchAsOfMs = batchAsOfMs;
      S.shouldApplyLiveSlots = shouldApplyLiveSlots;
      S.startMonthSweep = startMonthSweep;
      S.schedulePushRefresh = schedulePushRefresh;
      S.scheduleCatalogRefresh = scheduleCatalogRefresh;
      S.stopMonthSweep = stopMonthSweep;
      S.liveStreamEndpoint = liveStreamEndpoint;
      S.bindLiveStream = bindLiveStream;
      S.ensureStreamHealthy = ensureStreamHealthy;
      S.teardownLiveStream = teardownLiveStream;
      S.bindStreamLifecycleOnce = bindStreamLifecycleOnce;
      S.ensureLivePoll = ensureLivePoll;
      S.daysKeysFingerprint = daysKeysFingerprint;
      S.slotStructureFingerprint = slotStructureFingerprint;
      S.slotBookabilityFingerprint = slotBookabilityFingerprint;
      S.slotBookableBitFingerprint = slotBookableBitFingerprint;
      S.mergeLiveSlotsIntoList = mergeLiveSlotsIntoList;
      S.slotsInViewMonth = slotsInViewMonth;
      S.slotsForHotLivePoll = slotsForHotLivePoll;
      S.viewMonthBounds = viewMonthBounds;
      S.slotsForLivePoll = slotsForLivePoll;
      S.sweepViewMonthLive = sweepViewMonthLive;
      S.scheduleLiveFollowup = scheduleLiveFollowup;
      S.refreshLiveNow = refreshLiveNow;
      S.applyLiveSlots = applyLiveSlots;
      S.enrichSlotsForCurrentVenue = enrichSlotsForCurrentVenue;
      S.refreshVenueEventsLive = refreshVenueEventsLive;
      S.quietEnrichCurrentSlots = quietEnrichCurrentSlots;
      S.resetLiveCursors = resetLiveCursors;
    }
  };
})(typeof window !== "undefined" ? window : this);
